module.exports = __webpack_public_path__ + "static/media/20240530085856_IMG_7489.dde3d9b7.JPG";